import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})

export class HomeComponent implements OnInit {
  isLoading = true;
  resourceKeyValue: any;

  constructor() { }

  ngOnInit(): void {
    this.isLoading = false;
  }

}
